export default __webpack_public_path__ + "static/media/d_news.e3b15bed.png";